import React from 'react';
import i18n from '../../I18n';
import { ADDITIOONAL_DATA_TYPE } from 'utils/CustomEnums';
import OtherInfoTextField from './otherInfoUtils/OtherInfoTextField';
import OtherInfoDatetimeField from './otherInfoUtils/OtherInfoDatetimeField';
import OtherInfoToggleField from './otherInfoUtils/OtherInfoToggleField';
import OtherInfoDropdownField from './otherInfoUtils/OtherInfoDropdownField';
import OtherInfoSelectionField from './otherInfoUtils/OtherInfoSelectionField';

const QuestionSection = ({
  language,
  question,
  isConfirm,
  editAction,
}) => {
  if (
    question.questionFormat === ADDITIOONAL_DATA_TYPE.TEXT ||
    question.questionFormat === ADDITIOONAL_DATA_TYPE.NUMBER
  ) {
    return (
      <OtherInfoTextField
        language={language}
        isConfirm={isConfirm}
        placeholder={question.placeholder}
        defaultValue={question.defaultValue}
        isNumeral={question.questionFormat === ADDITIOONAL_DATA_TYPE.NUMBER}
        fieldName={question.fieldName}
        editAction={editAction}
      />
    );
  }
  if (question.questionFormat === ADDITIOONAL_DATA_TYPE.DATETIME) {
    return (
      <OtherInfoDatetimeField
        language={language}
        isConfirm={isConfirm}
        placeholder={question.placeholder}
        defaultValue={question.defaultValue}
        fieldName={question.fieldName}
        editAction={editAction}
        maxDate={null}
        minDate={null}
        precision={question.precision}
      />
    );
  }
  if (
    question.questionFormat === ADDITIOONAL_DATA_TYPE.TOGGLE ||
    question.questionFormat === ADDITIOONAL_DATA_TYPE.CHECKBOX
  ) {
    return (
      <OtherInfoToggleField
        language={language}
        isConfirm={isConfirm}
        defaultValue={question.defaultValue}
        fieldName={question.fieldName}
        editAction={editAction}
      />
    );
  }
  if (question.questionFormat === ADDITIOONAL_DATA_TYPE.DROPDOWN) {
    return (
      <OtherInfoDropdownField
        language={language}
        isConfirm={isConfirm}
        placeholder={question.placeholder}
        defaultValue={question.defaultValue}
        fieldName={question.fieldName}
        editAction={editAction}
        sections={question.options}
      />
    );
  }
  if (
    question.questionFormat === ADDITIOONAL_DATA_TYPE.SINGLE_CHOICES ||
    question.questionFormat === ADDITIOONAL_DATA_TYPE.MULTI_CHOICES
  ) {
    return (
      <OtherInfoSelectionField
        language={language}
        isConfirm={isConfirm}
        title={question.title}
        placeholder={question.placeholder}
        defaultValue={question.defaultValue}
        fieldName={question.fieldName}
        editAction={editAction}
        sections={question.options}
        isSingleSection={question.questionFormat === ADDITIOONAL_DATA_TYPE.SINGLE_CHOICES}
        optional={question.optional}
      />
    );
  }
  return null;
}


const SingleQuestion = ({
  language,
  question = {},
  isConfirm,
  editAction,
}) => (
  <div>
    <div>
      <label className='ticket_question_title body-2'>
        {question.title} {question.optional ? i18n.t('personal_info_optional') : null}
      </label>
    </div>

    <QuestionSection
      language={language}
      question={question}
      isConfirm={isConfirm}
      editAction={editAction}
    />
  </div>
)

const OtherInfoSection = ({
  language,
  showOtherInfo,
  questionData,
  setQuestionData,
  isConfirm,
}) => {
  console.log("@@questionData:", questionData)

  const editAction = (fieldName, value) => {
    setQuestionData(previousData => (
      (previousData || [])?.map(item => {
        if (item.fieldName === fieldName) {
          item.defaultValue = value
        };
        return item;
      })
    ))
  }

  if (!showOtherInfo || !questionData?.length) {
    return null;
  };

  return (
    <div className='ticket_other_info_container'>
      <div>
        <label className='ticket_other_info_title headline'>
          {i18n.t('otherInformation')}
        </label>
      </div>
      <div>
        {questionData?.map((question, index) => (
          <SingleQuestion
            language={language}
            key={`question-${question?.title}`}
            question={question}
            isConfirm={isConfirm}
            editAction={editAction}
          />
        ))}
      </div>
    </div>
  );
};

export default OtherInfoSection;
